import { createSvgIconComponent } from "../utils";
export var IconToolTip = createSvgIconComponent({
  viewBox: "0 0 20 20",
  path: "M9,5h2v2H9V5z M9,9h2v6H9V9z M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0z M10,18c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S14.4,18,10,18z"
});